export default __webpack_public_path__ + "static/PromptIconFour-cbb3e2559c3695816759cdbb34d13b39.png";